import { render, staticRenderFns } from "./CcPayments.vue?vue&type=template&id=70f9f8b0&"
import script from "./CcPayments.vue?vue&type=script&lang=js&"
export * from "./CcPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports